import {Injectable} from '@angular/core';
import {ToastService} from '../misc/toast.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(
    private http: HttpClient,
    private toast: ToastService,
  ) {
  }

  create(request_body) {
    return new Promise(resolve => {
      this.http.post(`${environment.api_url}/user/create`, request_body).pipe(
        this.toast.observe('Record Saving..', 'Successfully Saved', 'Something Went Wrong')
      ).subscribe(res => {
        resolve(res);
      });
    });
  }

  update(request_body) {
    return new Promise(resolve => {
      this.http.put(`${environment.api_url}/user/update`, request_body).pipe(
        this.toast.observe('Record Updating..', 'Successfully Updated', 'Something Went Wrong')
      ).subscribe(res => {
        // @ts-ignore
        resolve(res);
      });
    });
  }

  list() {
    return new Promise(resolve => {
      this.http.get(`${environment.api_url}/user`).subscribe(res => {
        resolve(res);
      });
    });
  }

  delete(request_body) {
    return new Promise(resolve => {
      this.http.delete(`${environment.api_url}/user/delete/${request_body}`).pipe(
        this.toast.observe('Record Deleting..', 'Successfully Deleted', 'Something Went Wrong')
      ).subscribe(res => {
        // @ts-ignore
        resolve(res.data);
      });
    });
  }

  show(request_body) { //method changed
    return new Promise(resolve => {
      this.http.get(`${environment.api_url}/user/show/${request_body}`).subscribe(res => {
        resolve(res);
      });
    });
  }

  authShow(request_body) {
    return new Promise(resolve => {
      this.http.get(`${environment.auth_url}/user/show/${request_body}`).subscribe(res => {
        resolve(res);
      });
    });
  }

  checkUserEmail(request_body) {
    return new Promise( resolve => {
      this.http.post(`${environment.auth_url}/find`, request_body).subscribe( res => {
        resolve(res);
      });
    });
  }

  updateUserPassword(request_body) {
    return new Promise( resolve => {
      this.http.post(`${environment.auth_url}/update/password`, request_body).subscribe( res => {
        resolve(res);
      });
    });
  }

  updateWithoutToast(request_body) {
    return new Promise(resolve => {
      this.http.put(`${environment.auth_url}/user/update`, request_body).pipe(
      ).subscribe(res => {
        // @ts-ignore
        resolve(res);
      });
    });
  }

  sendResetOTP(request_body) {
    return new Promise(resolve => {
      this.http.put(`${environment.auth_url}/send/reset/otp`, request_body).pipe(
      ).subscribe(res => {
        // @ts-ignore
        resolve(res);
      });
    });
  }

}
